import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  constructor(
    private readonly transloco: TranslocoService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  getWebsiteLanguage(): string {
    // 1) Transloco active lang
    const t = this.transloco.getActiveLang();
    if (t) return t.slice(0, 2).toLowerCase();

    // 2) <html lang> (set by AppComponent)
    if (isPlatformBrowser(this.platformId)) {
      const docLang = document.documentElement.lang;
      if (docLang) return docLang.slice(0, 2).toLowerCase();

      // 3) navigator fallback
      const nav = navigator.language;
      if (nav) return nav.slice(0, 2).toLowerCase();
    }

    // 4) default
    return 'en';
  }
}
